import React, { memo, useMemo } from 'react';
import cn from 'clsx';
import { css } from 'linaria';
import { Navigation } from 'swiper';
import { SwiperProps } from 'swiper/react/swiper-react';
import 'swiper/modules/navigation/navigation.min.css';
import { Swiper } from './swiper';

export const swiperNavigation = css`
  && {
    position: static;
    user-select: none;

    .swiper-button-next.swiper-button-disabled,
    .swiper-button-prev.swiper-button-disabled {
      cursor: auto;
      opacity: 0;
      pointer-events: none;
    }

    .swiper-button-prev {
      top: 50%;
      left: -24px;
      width: 48px;
      height: 48px;
      background-color: var(--background-primary);
      border: 2px solid var(--control-secondary);

      border-radius: 100%;

      @media (--to-tablet) {
        display: none;
      }

      &:hover {
        border: 2px solid var(--control-hover-secondary);
      }

      &::after {
        content: '';
        width: 24px;
        height: 24px;
        background-image: url(https://cdn.lemanapro.ru/lmru/image/upload/fudzi/elbrus/images/landings/engineering-systems/swiper-arrow-2.png/swiper-arrow-2.png);
        background-repeat: no-repeat;
        background-position: 50%;
        background-size: contain;
        border-radius: 50%;
        transform: scaleX(-1);
      }
    }

    .swiper-button-next {
      top: 50%;
      right: -24px;
      width: 48px;
      height: 48px;
      background-color: var(--background-primary);
      border: 2px solid var(--control-secondary);

      border-radius: 100%;

      @media (--to-tablet) {
        display: none;
      }

      &:hover {
        border: 2px solid var(--control-hover-secondary);
      }

      &::after {
        content: '';
        width: 24px;
        height: 24px;
        background-image: url(https://cdn.lemanapro.ru/lmru/image/upload/fudzi/elbrus/images/landings/engineering-systems/swiper-arrow-2.png/swiper-arrow-2.png);
        background-repeat: no-repeat;
        background-position: 50%;
        background-size: contain;
        border-radius: 50%;
      }
    }
  }
`;

const swiperNavigationWrapper = css`
  position: relative;
  width: 100%;
  height: 100%;
`;

export const staticSwiperContainer = css`
  position: static;
`;

type SwiperWithNavigationProps = {
  staticContainer?: boolean;
} & SwiperProps;

export const SwiperWithNavigation: React.FC<SwiperWithNavigationProps> = memo(
  ({ modules, className, staticContainer = false, ...rest }) => {
    const swiperModules = useMemo(() => {
      if (modules) {
        return [Navigation, ...modules];
      }
      return [Navigation];
    }, [modules]);

    return (
      <div className={cn(swiperNavigationWrapper, { [staticSwiperContainer]: staticContainer })}>
        <Swiper className={cn(swiperNavigation, className)} modules={swiperModules} navigation {...rest} />
      </div>
    );
  }
);
